import React from 'react'
import { Link } from 'react-router-dom'
import { API } from '@Root/API'
import { HandbookTable } from '../HandbookTable'
import { useHandbookApi } from '../useHandbookApi'
import { ErrorState, FormBadge, LoadingState, Section, TileLink } from '../ui'
import styles from '../style.module.scss'

const fetchHub = () => Promise.all([API.handbook.getCognito(), API.handbook.getReference()]).then(([cognito, reference]) => ({
  data: {
    tables: cognito.data?.tables || [],
    references: reference.data?.tables || [],
  },
}))

export const HandbookHub = () => {
  const { data, loading, error } = useHandbookApi(fetchHub)

  if (loading) {
    return <LoadingState />
  }
  if (error) {
    return <ErrorState>Unable to load handbook data.</ErrorState>
  }

  return (
    <>
      <div className={styles.pageHead}>
        <p className={styles.kicker}>TEID Handbook</p>
        <p className={styles.lead}>Data contracts for Cognito mapping, student CSV import, and HESA lookup tables. Each section is a separate pipeline.</p>
      </div>
      <div className={styles.sectionGrid}>
        <Link className={styles.sectionCard} to='/home/handbook/cognito'>
          <span className={styles.kicker}>01</span>
          <h2>Cognito mapping</h2>
          <p>Webhook field mapping from Cognito Forms to TEID tables, transforms, and application confirm sync.</p>
        </Link>
        <Link className={styles.sectionCard} to='/home/handbook/import/student-csv'>
          <span className={styles.kicker}>02</span>
          <h2>Student CSV import</h2>
          <p>Students tab CSV columns, required headers, Additional Fields, and Configure Export vs import.</p>
        </Link>
        <Link className={styles.sectionCard} to='/home/handbook/reference'>
          <span className={styles.kicker}>03</span>
          <h2>Reference tables</h2>
          <p>HESA and lookup code lists used by Cognito mapping and the admissions UI.</p>
        </Link>
      </div>
      {data?.tables?.length > 0 && (
        <Section title='Mapped tables' hint='Jump to a TEID table catalog used in Cognito field mapping.'>
          <div className={styles.tileGrid}>
            {data.tables.map(table => (
              <TileLink
                key={table.slug}
                to={`/home/handbook/cognito/fields/${table.slug}`}
                title={table.table}
                badge={<FormBadge type={table.form_type} />}
                meta={`${table.field_count} fields`}
              />
            ))}
          </div>
        </Section>
      )}
      {data?.references?.length > 0 && (
        <Section title='Lookup tables'>
          <HandbookTable
            columns={[
              { key: 'title', label: 'Reference', render: (value, row) => <Link to={`/home/handbook/reference/${row.slug}`}>{value}</Link> },
              { key: 'table', label: 'Source', render: value => <code>{value}</code> },
              { key: 'search_field', label: 'Search field', render: value => <code>{value}</code> },
            ]}
            rows={data.references}
          />
        </Section>
      )}
    </>
  )
}
